module.exports = __webpack_public_path__ + "img/TRACTOR_CHASSIS TRAILER_TUBE SKID_LHD_THUMB.9d0e238a.jpg";